import Icon from '2-core-elements/Icon/Icon';
import { careerDateFormat } from 'utils/careerDateFormat';

export type CareerCardProps = {
    link?: { href: string; label?: string; target?: '_self' | '_blank' };
    title: string;
    date?: string;
    location?: string;
    employmentType?: string;
    department?: string;
    children?: React.ReactNode;
};

const CardCareer = ({
    link = { href: '', label: '', target: '_self' },
    title,
    children,
    location,
    employmentType,
    department,
    date,
}: CareerCardProps): JSX.Element => {
    return (
        <a href={link.href} aria-label={title}>
            <div className="career-card" aria-label={title}>
                <div className="card-content py-8 px-4 flex flex-wrap box-border">
                    <div className="w-full md:w-5/12 box-border">
                        <div className="flex flex-wrap px-2">
                            <div className="w-full md:w-2/3 mb-4 md:mb-0">
                                <h2 className="card-title font-bold mb-4">
                                    {title}
                                </h2>
                                {date && (
                                    <div className="job-posted-date flex flex-wrap gap-2 items-center">
                                        <Icon icon="time" className="icon-xl" />
                                        <time dateTime={date}>
                                            {careerDateFormat(date)}
                                        </time>
                                    </div>
                                )}
                            </div>
                            <div className="w-full md:w-1/3">
                                <div className="job-summary flex flex-wrap gap-2 items-center mb-2">
                                    <p className="font-bold flex">
                                        <svg className="svg-icon location_on svg-icon icon-xl location_on" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                            <g className="location_on" xmlns="http://www.w3.org/2000/svg">
                                                <path fill="currentColor" d="M12 12c.55 0 1.02-.196 1.412-.588.392-.391.588-.862.588-1.412 0-.55-.196-1.02-.588-1.412A1.926 1.926 0 0 0 12 8c-.55 0-1.02.196-1.412.588A1.926 1.926 0 0 0 10 10c0 .55.196 1.02.588 1.412.391.392.862.588 1.412.588Zm0 10c-2.683-2.283-4.688-4.404-6.013-6.363C4.662 13.68 4 11.867 4 10.2c0-2.5.804-4.492 2.412-5.975C8.021 2.742 9.883 2 12 2s3.98.742 5.587 2.225C19.197 5.708 20 7.7 20 10.2c0 1.667-.663 3.48-1.988 5.438C16.688 17.595 14.683 19.716 12 22Z" className="vector" />
                                            </g>
                                        </svg>
                                        {location}
                                    </p>
                                </div>
                                <div className="job-summary flex flex-wrap gap-2 items-center mb-2">
                                    <p className="font-bold flex">
                                        <Icon icon="description" className="icon-xl" />
                                        {employmentType}
                                    </p>
                                </div>
                                <div className="job-summary flex flex-wrap gap-2 items-center mb-2">
                                    <p className="font-bold flex">
                                        <Icon icon="star" className="icon-xl" />
                                        {department}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="w-full md:w-7/12 box-border">
                        <div className="flex flex-wrap px-2">
                            <div className="w-full md:w-4/5 mb-4 md:mb-0">
                                {children && (
                                    <div className="card-description">
                                        {children}
                                    </div>
                                )}
                            </div>
                            <div className="w-full md:w-1/5 flex flex-wrap md:justify-end content-start">
                                <button type="button" className="link-skin-1 link-has-icons link-size-md">
                                    <p className="font-bold">Apply Now</p>
                                    <Icon icon="chevron-right" className="icon-xl" />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </a>
    );
};

export default CardCareer;
